import { OfferCardListingSkeletonContainer } from './OfferCardListingSkeletonLoader.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferCardListingSkeletonLoader: React.FC<any> = () => {
  return (
    <OfferCardListingSkeletonContainer>
      <div className="skeleton-loader heading"></div>
      <div className="card">
        <div className="card-content">
          <div className="skeleton-loader card-heading"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-button"></div>
        </div>
        <div className="skeleton-loader card-image"></div>
      </div>
      <div className="card">
        <div className="skeleton-loader card-image"></div>
        <div className="card-content">
          <div className="skeleton-loader card-heading"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-button"></div>
        </div>
      </div>
      <div className="card">
        <div className="card-content">
          <div className="skeleton-loader card-heading"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-p"></div>
          <div className="skeleton-loader card-button"></div>
        </div>
        <div className="skeleton-loader card-image"></div>
      </div>
      <div className="skeleton-loader button"></div>
    </OfferCardListingSkeletonContainer>
  );
};
